<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="PARÁMETROS" key="1">
        <a-form-model :model="filterParams" v-bind="fiOptions" ref="filterForm">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colSpan">
              <a-form-model-item :label="$t('Compañía')" prop="company" has-feedback
                                 :rules="[{ required: false, message: 'Valor requerido' }]">
                <form-model-dropdown style="width: 100%"
                                     v-model="filterParams.company"
                                     endpoint="company">
                </form-model-dropdown>
              </a-form-model-item>
            </a-col>
            <a-col v-bind="colSpan">
              <a-form-model-item :label="$t('Tipo de pago')" prop="company" has-feedback
                                 :rules="[{ required: false, message: 'Valor requerido' }]">
                <form-model-dropdown style="width: 100%"
                                     v-model="filterParams.tpay"
                                     endpoint="hierarchy_lookup"
                                     :params="tpay">
                </form-model-dropdown>
              </a-form-model-item>
            </a-col>
            <a-col v-bind="colSpan">
              <a-form-model-item :wrapper-col="{ span: 16 }">
                <a-button type="primary" @click="filtrar">Filtrar</a-button>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-tab-pane>
    </a-tabs>
    <a-tabs>
      <a-tab-pane tab="CONCEPTOS X EMPLEADO" key="1">
        <div style="display:flex; justify-content:flex-end; width:100%; padding:0;">
          <a-button :loading="buttonExcelLoading" style="background-color: rgb(29, 111, 66); color: white"
                    icon="file-excel" @click="exportarExcel()">
            Excel
          </a-button>
        </div>
        <br>
        <g-datatable :endpoint="masterPayrolXConcepto.endpoint"
                     :columns="masterPayrolXConcepto.tableSetup.columns"
                     :tableConfig="masterPayrolXConcepto.tableSetup.tableConfig"
                     :customSlots="masterPayrolXConcepto.tableSetup.customSlots"
                     :requestData="filterParams"
                     @params="paramsTable"
                     :key="key">
          <div slot="devRender" slot-scope="{record, text}" style="text-align: right;">
            <span style="color: green;">{{format(parseInt(text))}}</span>
          </div>

          <div slot="dedRender" slot-scope="{record, text}" style="text-align: right;">
            <span style="color: red;">{{format(parseInt(text))}}</span>
          </div>

          <div slot="defaultRender" slot-scope="{record, text}" style="text-align: right;">
            <span style="color: blue;">{{format(parseInt(text))}}</span>
          </div>
        </g-datatable>
      </a-tab-pane>
    </a-tabs>
  </div>

</template>
<script>
  import NumberUtils from '@/util/NumberUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        paramsT: {},
        tpay: {
          h_lookup_type: 'TIPO PAGO',
          use_code: true
        },
        buttonExcelLoading: false,
        tabActivo: 1,
        colSpan: {
          xs: 24,
          md: 8
        },
        key: 0,
        loadData: null,
        masterPayrolXConcepto: {
          endpoint: 'payroll_management/empleado_x_concepto',
          tableSetup: {
            tableConfig: {
              rowKey: '1',
              pagination: {
                pageSize: 20,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '20', '40', '60', '80', '100', '200', '500', '1000', '10000'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            customSlots: ['devRender', 'dedRender', 'defaultRender'],
            columns: []
          }
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        filterParams: {
          company: null,
          tpay: null
        }
      }
    },
    created () {
      this.httpClient = new HttpUtil()
      this.labelColumns()
    },
    watch: {
      loadData () {
        this.key++
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      },
      exportarExcel () {
        this.buttonExcelLoading = true
        this.httpClient.getInstance().get('payroll_management/downloadExcel', {
          responseType: 'arraybuffer',
          params: {
            company: this.filterParams.company,
            tpay: this.filterParams.tpay,
            ...this.paramsT
          }
        })
          .then(response => {
            let fileURL = new Blob([response.data], {type: response.headers['content-type']})
            fileURL = window.URL.createObjectURL(fileURL)
            let fileLink = document.getElementById('file_link_elm')
            if (fileLink === null) {
              fileLink = document.createElement('a')
              fileLink.setAttribute('id', 'file_link_elm')
              document.body.appendChild(fileLink)
            }

            fileLink.setAttribute('href', fileURL)
            fileLink.setAttribute('download', 'ConceptosXEmpleado.xlsx')
            fileLink.click()
            this.buttonExcelLoading = false
            Mensajes.success('Correcto', 'Se descargó su archivo con éxito.')
          })
          .catch(() => {
            this.buttonExcelLoading = false
            Mensajes.error('Error', 'No fue posible descargar el archivo.')
          })
          .then(() => {
            this.buttonExcelLoading = false
          })
      },
      labelColumns () {
        this.httpClient.getInstance().get('payroll_management/label')
          .then(response => {
            let columnasDisponibles = response.data
            for (let columna in columnasDisponibles) {
              if (columnasDisponibles.hasOwnProperty(columna)) {
                let columnModel = columnasDisponibles[columna]
                let newColumnDef = {
                  title: columnModel.label,
                  dataIndex: columna,
                  sorter: true
                }
                if (columnModel.key) {
                  newColumnDef.scopedSlots = {
                    filterDropdown: 'filterDropdown',
                    filterIcon: 'filterIcon',
                    customRender: columnModel.natu === 'DEV' ? 'devRender' : (columnModel.natu === 'DED' ? 'dedRender' : 'defaultRender')
                  }
                }
                this.masterPayrolXConcepto.tableSetup.columns.push(newColumnDef)
              }
            }
          })
          .catch(() => {})
          .then(() => {
            this.loadData = 1
          })
      },

      filtrar () {
        if (!this.$isEmpty(this.filterParams.company) || !this.$isEmpty(this.filterParams.tpay)) {
          this.filterParams = {
            company: this.filterParams.company,
            tpay: this.filterParams.tpay
          }
        } else {
          this.filterParams = {}
        }
      },
      format (value) {
        return NumberUtils.formatMoney(value, 0)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Reportes/ConceptosXEmpleado/ConceptosXEmpleado.vue